import { render, staticRenderFns } from "./FAQHeader.vue?vue&type=template&id=b785881c&scoped=true&"
import script from "./FAQHeader.vue?vue&type=script&lang=ts&"
export * from "./FAQHeader.vue?vue&type=script&lang=ts&"
import style0 from "./FAQHeader.vue?vue&type=style&index=0&id=b785881c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b785881c",
  null
  
)

export default component.exports